import AppConstant from '../../../../config/app.constants';

class reportingController {
    /*@ngInject*/
    constructor($state, Modal, $translate, $q, RouteService, User, DateUtil, SetupService, TruckService, UsersService, UserBranchService) {
        this.$state = $state;
        this.$translate = $translate;
        this.$q = $q;
        this.Modal = Modal;
        this.RouteService = RouteService;
        this.User = User;
        this.DateUtil = DateUtil;
        this.SetupService = SetupService;
        this.TruckService = TruckService;
        this.UsersService = UsersService;
        this.UserBranchService = UserBranchService;
        this.acl = {};
        this.hasACL = {};
        this.id = 'liability';

        this.model = {
            liabilityReportObj: {
                loading: false,
                totalRecords: 0,
                results: [],
                pagination: {
                    page: 1,
                    total: 0,
                    pageLimit: 10,
                    maxPages: 10
                },
            },
            routeListObj: {
                totalRecords: 0,
                results: [],
                loading: false
            },
            truckListObj: {
                totalRecords: 0,
                results: [],
                loading: false
            },
            messengerListObj: {
                totalRecords: 0,
                results: [],
                loading: false
            },
            dateRangeOptions: {
                startDate: null,
                endDate: null,
            },
            branch: User.getUser().branchId,
            loggedInUser: User.getUser().id,
            userBranchList: [],
            selectedBranch: []
        }
    }

    $onInit() {
        for (let key in this.acl['reporting_' + this.id]) {
            this.hasACL[this.acl['reporting_' + this.id][key]] = true;
        }

        this.model.loading = true;

        this.$q.all([
            this.SetupService.get(this.model.branch),
            this.UserBranchService.getUserBranches(this.model.loggedInUser),
        ])
            .then((data) => {
                this.model.setupDetails = data[0];
                this.model.userBranchList = data[1].results;
                this.model.vaultDate = this.DateUtil.convertToDate(this.model.setupDetails.currentVaultDate);

                this.model.userBranchList.filter((branch) => {
                    if (branch.branchId == this.model.setupDetails.branchId) {
                        branch.ticked = true;
                    }
                })

                this.setDateRangeOptions('dateRangeOptions');
                this.model.dateRangeOptions.startDate = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
                this.model.dateRangeOptions.endDate = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');

                this.getRouteList();
                this.getTruckData();
                this.getMessangerData();
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                this.model.loading = false;
            })
    }

    setDateRangeOptions(modelValue) {
        this.model[modelValue] = {
            autoApply: true,
            eventHandlers: {
                'apply.daterangepicker': () => {
                    // this.loadData();
                }
            },
            ranges: {
                'Previous Week': [
                    moment().subtract(7, 'days').format('YYYY-MM-DD HH:mm:ss'),
                    moment().subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Today': [
                    moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                    moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Current Week': [
                    moment().startOf('week').format('YYYY-MM-DD HH:mm:ss'),
                    moment().endOf('week').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Current Month': [
                    moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
                    moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Last 60 Days': [
                    moment().subtract('59', 'days').format('YYYY-MM-DD HH:mm:ss'),
                    moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
                ],
            }
        }
    }

    getStartDate() {
        return this.model.dateRangeOptions.startDate ? moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss') : null;
    }

    getEndDate() {
        return this.model.dateRangeOptions.endDate ? moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD HH:mm:ss') : null;
    }

    getRouteList(searchKey, offset) {
        setTimeout(() => {
            searchKey = searchKey || '';

            const routeSearchObj = {
                queryJSON: {
                    rules: [
                        {
                            field: 'branchId',
                            condition: 'IN',
                            data: this.getSelectedBranches()
                        },
                        {
                            group: {
                                rules: [{
                                    field: 'id',
                                    condition: 'like',
                                    data: '%' + searchKey + '%'
                                },
                                {
                                    field: 'name',
                                    condition: 'like',
                                    data: '%' + searchKey + '%'
                                }
                                ],
                                operator: 'OR'
                            }
                        }
                    ],
                    operator: 'AND'
                }
            };

            this.model.routeListObj.loading = true;
            return this.RouteService.all(routeSearchObj, offset, AppConstant.defaultPageLimit)
                .then((data) => {
                    if (offset == 0 || offset === undefined) {
                        this.model.routeListObj.totalRecords = data.total;
                        this.model.routeListObj.results = this.routeDataMapping(data.results);
                    } else {
                        const routes = this.routeDataMapping(data.results);
                        this.model.routeListObj.results = this.model.routeListObj.results.concat(routes);
                    }
                })
                .catch((err) => {
                    if (err && err.data && err.data.message) {
                        Modal.errorModal(err.data.message);
                    }
                })
                .finally(() => {
                    this.model.routeListObj.loading = false;
                })
        });
    }

    routeDataMapping(routes) {
        return routes.map((route) => {
            return {
                Key: route.name,
                Value: route.id
            }
        });
    }

    getTruckData(searchKey, offset) {
        setTimeout(() => {
            searchKey = searchKey || '';

            const searchObj = {
                queryText: '%' + searchKey + '%',
                isQuery: false,
                branch: this.getSelectedBranches().toString(),
                filterByAllBranch: false
            }

            this.model.truckListObj.loading = true;
            this.TruckService.all(searchObj, offset, AppConstant.defaultPageLimit)
                .then((data) => {
                    if (offset == 0 || offset === undefined) {
                        this.model.truckListObj.totalRecords = data.total;
                        this.model.truckListObj.results = this.mappingTruckData(data.results);
                    }
                    else {
                        const truckData = this.mappingTruckData(data.results);
                        this.model.truckListObj.results = this.model.truckListObj.results.concat(truckData);
                    }
                }).catch((err) => {
                    if (err && err.data && err.data.message) {
                        this.Modal.errorModal(err.data.message);
                    }
                })
                .finally(() => {
                    this.model.truckListObj.loading = false;
                })
        });
    }

    mappingTruckData(trucks) {
        return trucks.map((truck) => {
            return {
                Key: truck.id + " | " + truck.make,
                Value: truck.id
            }
        })
    }

    userSearchObj(searchKey) {
        searchKey = searchKey || '';
        const searchObj = {
            queryJSON: {
                rules: [
                    {
                        field: "branchId",
                        condition: "=",
                        data: this.getSelectedBranches()
                    },
                    {
                        group: {
                            rules: [
                                {
                                    field: "id",
                                    condition: "like",
                                    data: "%" + searchKey + "%"
                                },
                                {
                                    field: "firstName",
                                    condition: "like",
                                    data: "%" + searchKey + "%"
                                },
                                {
                                    field: "lastName",
                                    condition: "like",
                                    data: "%" + searchKey + "%"
                                }
                            ],
                            operator: "OR"
                        }
                    }
                ],
                operator: 'AND',
            }
        }

        if (searchKey) {
            searchObj.queryJSON.orderBy = {
                order: [
                    ['id', 'ASC']
                ]
            }
        }
        return searchObj.queryJSON.rules.length ? searchObj : null;
    };

    getMessangerData(searchKey, offset) {
        setTimeout(() => {
            let searchObj = this.userSearchObj(searchKey);

            this.model.messengerListObj.loading = true;
            this.UsersService.all(searchObj, offset, AppConstant.defaultPageLimit)
                .then((data) => {
                    if (offset == 0 || offset === undefined) {
                        this.model.messengerListObj.messangerTotalRecord = data.total;
                        this.model.messengerListObj.results = this.mappingUserData(data.results);
                    }
                    else {
                        const messanger = this.mappingUserData(data.results);
                        this.model.messengerListObj.results = this.model.messengerListObj.results.concat(messanger);
                    }
                })
                .catch((error) => {
                    console.error("Error:", error);
                })
                .finally(() => {
                    this.model.messengerListObj.loading = false;
                });
        });
    }

    mappingUserData = (userList) => {
        return userList.map((user) => {
            return {
                Key: user.id + " | " + user.firstName + ' ' + user.lastName,
                Value: user.id
            }
        })
    }

    getSelectedBranches() {
        return Array.isArray(this.model.selectedBranch) ? this.model.selectedBranch.map((branch) => branch.branchId) : null;
    }

    resetData() {
        this.model.route = null;
        this.model.truck = null;
        this.model.messenger = null;
    }
}

export default reportingController;


// WEBPACK FOOTER //
// ./client/app/components/reporting/components/liability/liability.controller.js